import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

// `step()` skips a target that is missing or hidden, so the optional steps
// (payment history button, pay button, checkout bar) only show when present.

registerTourPage('student-billing', {
  key: 'student-billing',
  label: 'Billing',
  getSteps: () => [
    step({
      target: '#tour-student-billing-summary',
      title: 'What you owe',
      content:
        'The big number is your balance owed: what you still have to pay. Below it you can see the total billed and how much you have paid so far.',
      placement: 'bottom',
    }),
    step({
      target: '[data-testid="btn-payment-history"]',
      title: 'Your payments and receipts',
      content:
        'Tap here to see every payment you have made and download a receipt for each one.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-student-billing-bills',
      title: 'Your bills',
      content:
        'Your bills, grouped by session. Tick the fees you want to pay now (or Select all), then use the button that ' +
        'appears at the bottom of the screen to choose how to pay. Fees with a lock belong to a newer bill: pay your ' +
        'older bills first.',
      placement: 'top',
    }),
  ],
});

registerTourPage('student-bill-detail', {
  key: 'student-bill-detail',
  label: 'Bill',
  getSteps: () => [
    introStep({
      title: 'Your bill',
      content:
        'Every fee on this bill, any discount taken off, what you have paid so far and the balance owed.',
    }),
    step({
      target: '[data-testid="btn-pay-outstanding"]',
      title: 'Paying this bill',
      content:
        'This button takes you to your bills with this bill\'s unpaid fees already selected (plus any older bills ' +
        'that must be paid first). Then choose how to pay.',
      placement: 'top',
    }),
  ],
});

registerTourPage('student-payment-history', {
  key: 'student-payment-history',
  label: 'Payment History',
  getSteps: () => [
    introStep({
      title: 'Payment history',
      content:
        'Every payment made on your account, newest first, with the date, the amount, how you paid and the reference. ' +
        'Payments that went through have a button to download the receipt. If a payment is still awaiting ' +
        'confirmation, please don\'t pay again: check back later.',
    }),
  ],
});

registerTourPage('student-payment-status', {
  key: 'student-payment-status',
  label: 'Payment Status',
  getSteps: () => [
    introStep({
      title: 'Did my payment go through?',
      content:
        'This page checks with the bank whether your payment went through. If it did, you can download your receipt ' +
        'here. If it is still being confirmed, please don\'t pay again: check back in a few minutes. If it didn\'t go ' +
        'through, you can try again.',
    }),
  ],
});

registerTourPage('student-financials', {
  key: 'student-financials',
  label: 'Financials',
  getSteps: () => [
    introStep({
      title: 'Student account',
      content:
        'This student\'s bills, payments, exemptions and balance owed, all in one place.',
    }),
  ],
});

registerTourPage('student-payments', {
  key: 'student-payments',
  label: 'Payments',
  getSteps: () => [
    introStep({
      title: 'Payments',
      content:
        'Every payment recorded for this student, with the amount, how it was paid and the reference. Use the page numbers under the table to see older payments.',
    }),
  ],
});
